import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

type Props = {
  open: boolean;
  title?: string;
  content: string;
  confirmLabel?: string;
  onConfirm?: () => void;
  onClose?: () => void;
};

const ConfirmDialog: React.FC<Props> = (props) => {
  return (
    <Dialog open={props.open} onClose={props.onClose} disableEscapeKeyDown>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={props.onConfirm}>
          {props.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.defaultProps = {
  title: 'エラー',
  confirmLabel: 'OK',
};

export default ConfirmDialog;
